<h2 mat-dialog-title>Creating your tenant database</h2>
<div mat-dialog-content>
    <p>Please email <a href="mailto:google.support@trafera.com">google.support&#64;trafera.com</a> for assistance on setting up a tenant database for your organization.</p>
    <div mat-dialog-actions class='px-0'>
        <button class="text-white" mat-stroked-button mat-dialog-close>Close</button>
    </div>
</div>